import React, { useEffect, useState } from 'react';
import api, { isSupervisorRole, getCurrentUser } from '../api/expoApi';
import HubSelector from '../components/HubSelector';

export default function SalesTargets() {
    const user = getCurrentUser();
    const isSupervisor = isSupervisorRole(user?.role);
    const [targets, setTargets] = useState([]);
    const [dashboard, setDashboard] = useState([]);
    const [hubId, setHubId] = useState(null);
    const [month] = useState(new Date().getMonth() + 1);
    const [year] = useState(new Date().getFullYear());
    const [newTarget, setNewTarget] = useState({
        sales_rep_id: '', hub_id: '', month, year,
        target_revenue: '', target_shipments: '', target_new_accounts: '', notes: ''
    });
    const [msg, setMsg] = useState('');

    const load = async () => {
        try {
            const [t, d] = await Promise.all([
                api.get('/sales-targets-extended', { params: hubId ? { hub_id: hubId } : {} }),
                api.get('/sales-targets-extended/dashboard', { params: { month, year, ...(hubId ? { hub_id: hubId } : {}) } })
            ]);
            setTargets(t.data?.data || []);
            setDashboard(d.data?.data || []);
        } catch (e) { console.error(e); }
    };

    useEffect(() => { load(); /* eslint-disable-next-line */ }, [hubId]);

    const createTarget = async () => {
        try {
            await api.post('/sales-targets-extended', newTarget);
            setMsg('Target created');
            setNewTarget({ ...newTarget, sales_rep_id: '', target_revenue: '', target_shipments: '', target_new_accounts: '', notes: '' });
            load();
        } catch (e) { setMsg(e.response?.data?.message || 'Error'); }
    };

    return (
        <div style={{ padding: 24 }}>
            <h1>Sales Targets</h1>
            <div style={{ display: 'flex', gap: 12, marginBottom: 16, alignItems: 'center' }}>
                <HubSelector value={hubId} onChange={setHubId} />
                <span>Period: {month}/{year}</span>
                {msg && <span style={{ color: '#198754' }}>{msg}</span>}
            </div>

            <h3>Hub Performance — {month}/{year}</h3>
            <table style={tableStyle}>
                <thead><tr><th>Hub</th><th>Target Revenue</th><th>Achieved Revenue</th><th>Target Shipments</th><th>Achieved Shipments</th><th>Target Accounts</th><th>Achieved Accounts</th></tr></thead>
                <tbody>
                    {dashboard.length === 0 && <tr><td colSpan="7" style={{ textAlign: 'center', padding: 16 }}>No targets set for this period</td></tr>}
                    {dashboard.map((h, i) => (
                        <tr key={i}>
                            <td>{h.hub_code} — {h.hub_name}</td>
                            <td>PKR {Number(h.total_target_revenue || 0).toLocaleString()}</td>
                            <td>PKR {Number(h.total_achieved_revenue || 0).toLocaleString()}</td>
                            <td>{h.total_target_shipments || 0}</td>
                            <td>{h.total_achieved_shipments || 0}</td>
                            <td>{h.total_target_accounts || 0}</td>
                            <td>{h.total_achieved_accounts || 0}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {isSupervisor && (
                <div style={{ background: '#f8f9fa', padding: 16, borderRadius: 6, marginTop: 24 }}>
                    <h3>Set Target</h3>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
                        <input placeholder="Sales rep ID (UUID)" value={newTarget.sales_rep_id} onChange={(e) => setNewTarget({...newTarget, sales_rep_id: e.target.value})} />
                        <input placeholder="Hub ID (UUID, optional)" value={newTarget.hub_id} onChange={(e) => setNewTarget({...newTarget, hub_id: e.target.value})} />
                        <input type="number" placeholder="Month" value={newTarget.month} onChange={(e) => setNewTarget({...newTarget, month: e.target.value})} />
                        <input type="number" placeholder="Year" value={newTarget.year} onChange={(e) => setNewTarget({...newTarget, year: e.target.value})} />
                        <input type="number" placeholder="Target revenue" value={newTarget.target_revenue} onChange={(e) => setNewTarget({...newTarget, target_revenue: e.target.value})} />
                        <input type="number" placeholder="Target shipments" value={newTarget.target_shipments} onChange={(e) => setNewTarget({...newTarget, target_shipments: e.target.value})} />
                        <input type="number" placeholder="Target accounts" value={newTarget.target_new_accounts} onChange={(e) => setNewTarget({...newTarget, target_new_accounts: e.target.value})} />
                        <input placeholder="Notes" value={newTarget.notes} onChange={(e) => setNewTarget({...newTarget, notes: e.target.value})} />
                    </div>
                    <button onClick={createTarget} style={{ marginTop: 8, padding: '8px 16px' }}>Create Target</button>
                </div>
            )}

            <h3 style={{ marginTop: 24 }}>All Targets</h3>
            <table style={tableStyle}>
                <thead><tr><th>Period</th><th>Sales Rep</th><th>Hub</th><th>Target Rev</th><th>Achievement</th></tr></thead>
                <tbody>
                    {targets.map((t) => (
                        <tr key={t.target_id}>
                            <td>{t.month}/{t.year}</td>
                            <td>{t.sales_rep_name}</td>
                            <td>{t.hub_code || '—'}</td>
                            <td>PKR {Number(t.target_revenue).toLocaleString()}</td>
                            <td>{t.revenue_pct !== null ? `${t.revenue_pct}%` : '—'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

const tableStyle = { width: '100%', borderCollapse: 'collapse', background: '#fff' };
